/**
 * 需求来源：docs/合作页、CJ Entity、Ads开户落地页3个/AI提示词.md（第2次提交 任务1）、advertisingservice.html。
 * Section 4：cj-real-benefits 6 项收益卡（深色背景 + Unsplash 实景图，PC 3 列 / iPad 2 列 / 移动 1 列）。
 * 注意事项：卡片文案（label/h3/p/alt）经 ConstantsContext 取词，配色与图片为视觉资产保留在组件内。
 */
import React, { useContext } from 'react';
import ConstantsContext from './ConstantsContext';
import { mix } from '../colorMix';
// 260715 第17次补充(需求㊷)：6 张实景图本地化，下载至 asset/images/advertisingservice 经 webpack 引用，不再外链 unsplash
import benefit1 from 'asset/images/advertisingservice/benefit-1.jpg';
import benefit2 from 'asset/images/advertisingservice/benefit-2.jpg';
import benefit3 from 'asset/images/advertisingservice/benefit-3.jpg';
import benefit4 from 'asset/images/advertisingservice/benefit-4.jpg';
import benefit5 from 'asset/images/advertisingservice/benefit-5.jpg';
import benefit6 from 'asset/images/advertisingservice/benefit-6.jpg';

// 视觉资产（accent 色 / 图片 / 裁切位置）顺序与 REAL_BENEFITS.cards 一一对应
var CARD_VISUALS = [
  { accent: '#6f8fff', pos: 'center 52%', img: benefit1 },
  { accent: '#a07cff', pos: 'center 45%', img: benefit2 },
  { accent: '#42c5c9', pos: 'center 52%', img: benefit3 },
  { accent: '#42be87', pos: 'center', img: benefit4 },
  { accent: '#ff9c63', pos: 'center', img: benefit5 },
  { accent: '#ef78b2', pos: 'center 48%', img: benefit6 },
];

// 由 accent 主色预算派生 CSS 变量（等价原 less 的 color-mix）
function accentVars(accent, pos) {
  if (!accent) return { '--image-position': pos };
  return {
    '--accent': accent,
    '--image-position': pos,
    '--accent-hover-bd': mix(accent, 'rgba(255,255,255,.12)', 42), // hover 描边
    '--accent-glow': mix(accent, 'transparent', 8),                // hover 外发光
    '--accent-veil': mix(accent, 'transparent', 18),               // 图上渐变纱
    '--accent-tint': mix(accent, '#ffffff', 12),                   // 内容区微光
    '--accent-link': mix(accent, '#172033', 78),                   // 链接文字
  };
}

function RealBenefits() {
  const { REAL_BENEFITS } = useContext(ConstantsContext);
  return (
    <section className="cj-real-benefits">
      <div className="cj-real-benefits__wrap">
        <div className="cj-real-benefits__head">
          <h2 className="cj-real-benefits__title">
            {REAL_BENEFITS.title}
            <span className="accent"> {REAL_BENEFITS.titleAccent}</span>
          </h2>
          <p className="cj-real-benefits__description">{REAL_BENEFITS.description}</p>
        </div>

        <div className="cj-real-benefits__grid">
          {REAL_BENEFITS.cards.map((c, i) => {
            var v = CARD_VISUALS[i] || {};
            return (
              <article className="cj-real-benefit-card" key={c.h3} style={accentVars(v.accent, v.pos)}>
                <div className="cj-real-benefit-card__media">
                  <img className="cj-real-benefit-card__image" src={v.img} alt={c.alt} loading="lazy" />
                  <span className="cj-real-benefit-card__image-label">{c.label}</span>
                </div>
                <div className="cj-real-benefit-card__content">
                  <h3>{c.h3}</h3>
                  <p>{c.p}</p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default RealBenefits;
